import GeneralMessageContainer from "./GeneralMessageContainer";
export default GeneralMessageContainer;
